module.exports = __webpack_public_path__ + "img/icon1_2.9c8e8fc7.png";